<template>
  <b-col md="12" class="mb-3">
    <b-card class="formCardDash">
      <div class="card-header">
        <h6 class="card-title mb-0">Billing & Invoice Details</h6>
      </div>
      <div class="card-body">
        <!-- Billing Summary Cards -->
        <b-row class="mb-3">
          <b-col md="3" sm="6" class="mb-2">
            <div class="summary-card-small bg-primary">
              <div class="card-content-small">
                <h5>Total Invoices</h5>
                <h4>{{ billingSummary.totalInvoices || 0 }}</h4>
              </div>
            </div>
          </b-col>
          <b-col md="3" sm="6" class="mb-2">
            <div class="summary-card-small bg-success">
              <div class="card-content-small">
                <h5>Total Billed Amount</h5>
                <h4>{{ formatCurrency(billingSummary.totalBilledAmount || 0) }}</h4>
              </div>
            </div>
          </b-col>
          <b-col md="3" sm="6" class="mb-2">
            <div class="summary-card-small bg-info">
              <div class="card-content-small">
                <h5>Paid Amount</h5>
                <h4>{{ formatCurrency(billingSummary.paidAmount || 0) }}</h4>
              </div>
            </div>
          </b-col>
          <b-col md="3" sm="6" class="mb-2">
            <div class="summary-card-small bg-warning">
              <div class="card-content-small">
                <h5>Pending Amount</h5>
                <h4>{{ formatCurrency(billingSummary.pendingAmount || 0) }}</h4>
              </div>
            </div>
          </b-col>
        </b-row>

        <div class="table-responsive">
          <table class="table table-bordered table-striped table-sm">
            <thead>
              <tr>
                <th>Invoice No</th>
                <th>Invoice Date</th>
                <th>Job No</th>
                <th>Assignment No</th>
                <th>Client Name</th>
                <th>Job Type</th>
                <th>Branch</th>
                <th>Invoice Amount</th>
                <th>Paid Amount</th>
                <th>Pending Amount</th>
                <th>Billing Status</th>
                <th>Tally Status</th>
                <th>Payment Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(billing, index) in billingData" :key="index">
                <td>{{ billing.invoiceNo }}</td>
                <td>{{ formatDate(billing.invoiceDate) }}</td>
                <td>{{ billing.jobNo }}</td>
                <td>{{ billing.assignmentNo }}</td>
                <td>{{ billing.clientName }}</td>
                <td>
                  <b-badge
                    :variant="
                      billing.jobType === 'FF_EXP'
                        ? 'primary'
                        : billing.jobType === 'FF_IMP'
                        ? 'info'
                        : billing.jobType === 'CC_EXP'
                        ? 'success'
                        : billing.jobType === 'CC_IMP'
                        ? 'warning'
                        : 'secondary'
                    "
                    >{{ billing.jobType }}</b-badge
                  >
                </td>
                <td>{{ billing.branchName }}</td>
                <td>{{ formatCurrency(billing.invoiceAmount) }}</td>
                <td>{{ formatCurrency(billing.paidAmount) }}</td>
                <td>
                  <span :class="billing.pendingAmount > 0 ? 'text-danger' : 'text-success'">
                    {{ formatCurrency(billing.pendingAmount) }}
                  </span>
                </td>
                <td>
                  <b-badge
                    :variant="
                      billing.billingStatus === 'Completed'
                        ? 'success'
                        : billing.billingStatus === 'Pending'
                        ? 'warning'
                        : 'secondary'
                    "
                    >{{ billing.billingStatus }}</b-badge
                  >
                </td>
                <td>
                  <b-badge
                    :variant="
                      billing.tallyStatus === 'Added to Tally'
                        ? 'success'
                        : billing.tallyStatus === 'Pending'
                        ? 'warning'
                        : 'secondary'
                    "
                    >{{ billing.tallyStatus }}</b-badge
                  >
                </td>
                <td>
                  <b-badge
                    :variant="
                      billing.paymentStatus === 'Paid'
                        ? 'success'
                        : billing.paymentStatus === 'Partial'
                        ? 'warning'
                        : 'danger'
                    "
                    >{{ billing.paymentStatus }}</b-badge
                  >
                </td>
              </tr>
              <tr v-if="billingData.length === 0">
                <td colspan="13" class="text-center text-muted">
                  No data available
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-card>
  </b-col>
</template>

<script>
import moment from "moment";

export default {
  name: "BillingSection",
  props: {
    billingSummary: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    billingData: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  methods: {
    formatCurrency(value) {
      if (!value) return "₹0";
      return "₹" + value.toLocaleString("en-IN");
    },
    formatDate(date) {
      if (!date) return "-";
      return moment(date).format("DD-MM-YYYY");
    },
  },
};
</script>

<style scoped>
.summary-card-small {
  padding: 15px;
  border-radius: 8px;
  color: white;
  text-align: center;
}

.card-content-small h5 {
  font-size: 14px;
  margin: 0 0 10px 0;
  opacity: 0.9;
}

.card-content-small h4 {
  font-size: 24px;
  font-weight: 600;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// BillingSection.vue?7c9901b0